import StockOverview from "./StockOverview";

export default function InventoryAdjustments() {
  return (
    <StockOverview
      title="Inventory Adjustments"
      subtitle="Review manual stock corrections and create new adjustments from a focused inventory adjustment workspace."
      initialTab="movements"
      lockedTab="movements"
      movementTypeFilter="ADJUSTMENT"
      showOpenWork={false}
      showAdjustAction
      showReceiveAction={false}
      historyTitle="Adjustment History"
    />
  );
}
